var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"__mpx_ref_collapse__",staticClass:"ts-collapse",class:(_vm.externClass),style:(_vm._f("transRpxStyle")([([_vm.transitionStyle,_vm.expandStyle])]))},[_c('div',{staticClass:"slot-container"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }